import { t } from "@/i18n-js/instance";
import { PostsDetailsContextProvider } from "@circle-react/contexts/postsDetailsContext";
import { usePostList } from "@circle-react/hooks/posts/usePostList";
import { SkeletonLoader } from "@circle-react-uikit/SkeletonLoader";
import { Typography } from "@circle-react-uikit/Typography";
import { EventsList } from "./EventsList";

const PAST_EVENTS_SORT = "desc";

export const PastEvents = ({ spaceId, isThumbnailView }: any) => {
  const {
    posts: events,
    mapPages,
    isLoading,
    fetchNextPage,
    hasNextPage,
    onPostDestroy,
    onPostChange,
  } = usePostList({
    sort: PAST_EVENTS_SORT,
    past_events: true,
  });
  const perPagePostIds = mapPages((page: any) =>
    page.records.map((post: any) => post.id),
  );

  if (isLoading) {
    return <SkeletonLoader variant="new-events-list-view" disableCoverImage />;
  }

  if (events.length === 0) return null;

  return (
    <PostsDetailsContextProvider
      perPagePostIds={perPagePostIds}
      spaceId={spaceId}
    >
      <div className="mx-6 my-3 md:mx-0">
        <Typography.TitleSm weight="bold">
          {t("events.past_events")}
        </Typography.TitleSm>
      </div>
      <EventsList
        activeSort={PAST_EVENTS_SORT}
        events={events}
        isPast
        isDraft={false}
        fetchNextPage={fetchNextPage}
        hasNextPage={Boolean(hasNextPage)}
        onPostDestroy={onPostDestroy}
        onPostChange={onPostChange}
        isNextEventEnabled={false}
        isThumbnailView={isThumbnailView}
      />
    </PostsDetailsContextProvider>
  );
};
